import { jsx as _jsx } from "react/jsx-runtime";
import Box, {} from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
/**
 * The Voicely brand, as the designer drew it for each canvas.
 *
 * `wordmark` is the name with the waveform as its "o" (about 3.4:1); `icon` is
 * the waveform on its teal tile (square, no padding). Each comes in a light
 * and a dark drawing, picked from the theme — the dark wordmark has near-white
 * letters rather than a CSS filter lifting the light one, which is what the
 * previous logo had to do for want of a dark variant.
 *
 * The SVGs are served from each app's `public/` at these paths, so every app
 * that renders this ships them.
 */
const SOURCES = {
    wordmark: { light: "/voicely-logo-light.svg", dark: "/voicely-logo-dark.svg" },
    icon: { light: "/voicely-icon-light.svg", dark: "/voicely-icon-dark.svg" },
};
export const BrandLogo = ({ variant, height, alt = "Voicely", onClick, sx }) => {
    const mode = useTheme().palette.mode === "dark" ? "dark" : "light";
    return (_jsx(Box, { component: "img", src: SOURCES[variant][mode], alt: alt, onClick: onClick, sx: [
            { height, width: "auto", display: "block", cursor: onClick ? "pointer" : undefined },
            ...(Array.isArray(sx) ? sx : [sx]),
        ] }));
};
//# sourceMappingURL=BrandLogo.js.map